import React, { useEffect, useState } from 'react';
import { FormTitle } from '../components/FormTitle';
import { AccessFormSimplified } from './AccessFormSimplified';
import { AccessFormComplete } from './AccessFormComplete';
import { useMemberData } from '../context/MemberDataContext';
import { AcceptTerms } from './Inputs/AcceptTerms';
import { ContinueButton } from './Inputs/ContinueButton';

type FormType = 'SIMPLE' | 'COMPLETE' | undefined;
interface AddressInput {
  streetName?: string,
  state?: string,
  country?: string,
  city?: string
}

export function FirstAccessForm() {
  const [formType, setFormType] = useState<FormType>();

  const memberData = useMemberData();

  const validateErrorInAddressList = (data: AddressInput) => {
    const fieldsToValidate = ['city', 'country', 'state', 'streetName'];
    const invalidValuesToValidate = ['N/A', 'N A', 'N /A', 'N/ A'];
    const findInvalidField = fieldsToValidate.find(field => {
      const result = data[field as keyof typeof data];
      if (!result) {
        return true;
      }
      const valueFormatted = result.toUpperCase().trim();
      return invalidValuesToValidate.includes(valueFormatted);
    })


    return !!findInvalidField;
  }

  useEffect(() => {
    const { response } = memberData;

    if (!response.ready) {
      return;
    }

    if (formType !== undefined) {
      return;
    }

    const { streetName, state, country, city } = memberData.data;
    const hasInvalidFieldInAddress = validateErrorInAddressList({ streetName, state, country, city });

    if (!hasInvalidFieldInAddress) {
      setFormType('SIMPLE');
      memberData.setFormType('SIMPLE');
      return;
    }

    setFormType('COMPLETE');
    memberData.setFormType('COMPLETE');
  }, [memberData, formType]);

  return (
    <>
      <FormTitle />
      <div className="first-access-form" data-testid="first-access-form">
        {formType === 'SIMPLE' && <AccessFormSimplified />}
        {formType === 'COMPLETE' && <AccessFormComplete />}
      </div>

      <div className="first-access-bottom" data-testid="first-access-bottom-container">
        <AcceptTerms />
        <ContinueButton />
      </div>
    </>
  );
}